jQuery(document).ready(function ($) {
    function isLiveChatEnable() {
        var usaTime = new Date().toLocaleString("en-US", {
            timeZone: "America/New_York"
        });
        usaTime = new Date(usaTime);

        var isLiveChat = true;
        if (usaTime.getDay() > 4 && usaTime.getHours() > 18) {
            isLiveChat = false;
        }

        return isLiveChat;
    }

    let idleTimer = null;
    let popupShown = false;

    function startModalCSSLoadingTimer() {
        setTimeout(function () {
            let fileref = document.createElement("link");
            fileref.rel = "stylesheet";
            fileref.type = "text/css";
            fileref.href = "/wp-content/themes/myusa/components/modal/modal.css";
            document.getElementsByTagName("head")[0].appendChild(fileref);
        }, 1000 * 15);
    }

    function startIdleTimer() {
        idleTimer = setTimeout(function () {
            if (popupShown === false) {
                if (isLiveChatEnable()) {
                    $('.live-chat-on').show();
                    $('.live-chat-off').hide();
                } else {
                    $('.live-chat-on').hide();
                    $('.live-chat-off').show();
                }
                popupShown = true;
                let popupImg = $('#idle-popup').find('img');
                popupImg.attr('src', 'https://myusacorporation-com-assets.s3.amazonaws.com/images/site/idle-popup.jpg');

                if ($('#idle-popup').length) {
                    $('#idle-popup').modal();
                }
            }
        }, 1000 * 60 * 1.5);
    }

    $(function () {
        startModalCSSLoadingTimer();
        startIdleTimer();

        $(document).on('keyup keypress scroll mousemove', function (e) {
            clearTimeout(idleTimer);
            startIdleTimer();
        });

        var topCnt = 0;
        $(document).bind("mouseleave", function (e) {
            if (e.pageY - $(window).scrollTop() <= 1) {
                if (topCnt < 2) {
                    topCnt++;
                    return;
                }
                var isIdleShow = localStorage.getItem('isIdleShow');
                if (isIdleShow === null) {
                    localStorage.setItem('isIdleShow', 'true');
                    if (isLiveChatEnable()) {
                        $('.live-chat-on').show();
                        $('.live-chat-off').hide();
                    } else {
                        $('.live-chat-on').hide();
                        $('.live-chat-off').show();
                    }
                    let popupImg = $('#leave-popup').find('img');
                    popupImg.attr('src', 'https://myusacorporation-com-assets.s3.amazonaws.com/images/site/leave-popup.jpg');
                    $('#leave-popup').modal();
                }
            }
        });
    });
});